import { type ObjectValuesUnionType } from '../../../utils/typing';

export const MPFamilyIds = Object.freeze({
  BROWN: 'BROWN',
  PURPLE: 'PURPLE',
  ORANGE: 'ORANGE',
  DARK_BLUE: 'DARK_BLUE',
  LIGHT_BLUE: 'LIGHT_BLUE',
  RED: 'RED',
  GREEN: 'GREEN',
  YELLOW: 'YELLOW',
  STATION: 'STATION',
  ENERGY: 'ENERGY',
});

export type MPFamilyId = ObjectValuesUnionType<typeof MPFamilyIds>;

export const MPFamilyStatuses = Object.freeze({
  OPEN: 'OPEN',
  WON: 'WON',
});

export type MPFamilyStatus = ObjectValuesUnionType<typeof MPFamilyStatuses>;
